import styled from "styled-components";

export const StyleFigure = styled.figure`
  height: 100%;
  width: 100%;
  outline: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
`;

export const StyleViewerIMG = styled.img<{
  textHeight?: number;
  alignmentLeft?: string | number;
  alignmentRight?: string | number;
  size?: string | number;
}>`
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: contain;
  display: block;
  margin-left: ${(props) => props.alignmentLeft};
  margin-right: ${(props) => props.alignmentRight};
  cursor: pointer;
`;

export const ImageContainer = styled.div<{
  width?: number;
  aspectRatio?: number;
  alignmentLeft?: string | number;
  alignmentRight?: string | number;
  textHeight?: number;
}>`
  width: ${({ width }) => (width ? `${width}%` : "100%")};
  aspect-ratio: ${({ aspectRatio }) => (aspectRatio ? aspectRatio : "auto")};
  height: ${(props) => (props?.textHeight ? `calc(100% - ${props.textHeight}px)` : "100%")};
  margin-left: ${(props) => props.alignmentLeft};
  margin-right: ${(props) => props.alignmentRight};
`;

export const StyleCaption = styled.figcaption`
  text-align: center;
  font-style: italic;
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  position: relative;
  line-height: 15px;
  width: 100%;
`;

export const StyleLayoutItem = styled.div`
  &.component-credit {
    padding-bottom: 5px;
    width: 100%;
  }
  .mathml-expression {
    display: inline-block;
    height: 100%;

    svg {
      box-sizing: content-box;
      vertical-align: middle;
    }
  }
  &.component-credit > p,
  &.component-caption > p {
    margin: 0;
  }
  /* the theme's "body p" margins come back rescoped under the container id,
     which outranks the class rule above; BV's credit paragraph has no margin,
     so match it with the id. Captions stay unboosted: BV shows the theme
     margin there too. */
  #viewer-express-container &&.component-credit > p {
    margin: 0;
  }
`;

export const StyleLongDescription = styled.div`
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

export const StyleLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto visible;
  height: 100%;
  font-family: var(--body-font, Arial, sans-serif);
  color: var(--text-color, rgba(0, 0, 0, 0.87));
`;

export const StyleActivityTitle = styled.h4`
  margin: 0;
  padding-bottom: 10px;
  font-family: var(--title-font, Arial, sans-serif);

  .mathml-expression {
    display: inline-block;
    height: 100%;

    svg {
      box-sizing: content-box;
      vertical-align: middle;
    }
  }

  & > span > p,
  & > p {
    display: inline-block;
    margin: 0;
  }

  & > .component-label,
  & > .component-title {
    display: block;
  }

  /* Theme CSS is rescoped under #viewer-express-container (cssProcessor), so its
     "body h4 { margin: 8px 0 -8px }" and "body p { margin-top: 2px }" gain ID
     specificity and beat the class rules above; in BV the same theme rules stay
     unscoped and lose. Re-assert the BV-winning values above the ID. */
  #viewer-express-container && {
    margin: 0;
  }

  #viewer-express-container && > span > p,
  #viewer-express-container && > p {
    display: inline-block;
    margin: 0;
  }
`;

export const StyleLayoutComponent = styled.div`
  flex: 1;
`;
